/* ============================================================
   ASTROX — THEME JS (vanilla, sin dependencias externas)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Utilidades ---------- */
  const qs = (sel, ctx) => (ctx || document).querySelector(sel);
  const qsa = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  async function fetchJSON(url, options) {
    const res = await fetch(url, options);
    if (!res.ok) throw new Error('Request failed: ' + url);
    return res.json();
  }

  /* ============================================================
     1. HEADER: ocultar al bajar, mostrar al subir
     ============================================================ */
  (function headerScrollBehavior() {
    const header = qs('[data-site-header]');
    if (!header) return;
    let lastY = window.scrollY;
    let ticking = false;

    function onScroll() {
      const currentY = window.scrollY;
      if (currentY > lastY && currentY > 120) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastY = currentY;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  })();

  /* ============================================================
     2. MENÚ MOBILE
     ============================================================ */
  (function mobileMenu() {
    const toggle = qs('[data-menu-toggle]');
    const menu = qs('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  })();

  /* ============================================================
     3. BÚSQUEDA OVERLAY
     ============================================================ */
  (function searchOverlay() {
    const toggle = qs('[data-search-toggle]');
    const overlay = qs('[data-search-overlay]');
    const close = qs('[data-search-close]');
    if (!toggle || !overlay) return;

    function open() {
      overlay.classList.add('is-open');
      const input = qs('[data-predictive-search-input]', overlay);
      if (input) setTimeout(() => input.focus(), 100);
    }
    function closeOverlay() { overlay.classList.remove('is-open'); }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', closeOverlay);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeOverlay(); });
  })();

  /* ============================================================
     4. CART DRAWER
     ============================================================ */
  const CartDrawer = (function () {
    const drawer = qs('[data-cart-drawer]');
    const closeBtns = qsa('[data-cart-close]');
    const toggleBtn = qs('[data-cart-toggle]');

    function open() {
      if (!drawer) return;
      drawer.hidden = false;
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => { drawer.hidden = true; }, 300);
    }

    if (toggleBtn) toggleBtn.addEventListener('click', open);
    closeBtns.forEach((btn) => btn.addEventListener('click', close));

    async function refresh() {
      try {
        const cart = await fetchJSON('/cart.js');
        qsa('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        window.ASTROX.cartItemCount = cart.item_count;
        // Recarga la sección del carrito vía fetch de la página actual (progressive enhancement)
        const res = await fetch(window.location.pathname + '?sections=cart-drawer');
        if (res.ok) {
          const data = await res.json();
          if (data['cart-drawer']) {
            const temp = document.createElement('div');
            temp.innerHTML = data['cart-drawer'];
            const newDrawer = qs('[data-cart-drawer]', temp);
            if (newDrawer && drawer) {
              drawer.innerHTML = newDrawer.innerHTML;
            }
          }
        }
      } catch (e) {
        console.error('ASTROX: no se pudo refrescar el carrito', e);
      }
    }

    return { open, close, refresh };
  })();

  /* ============================================================
     5. AGREGAR AL CARRITO (AJAX) + COMPRAR AHORA
     ============================================================ */
  (function productForm() {
    const forms = qsa('[data-product-form]');
    forms.forEach((form) => {
      const addBtn = qs('[data-add-to-cart]', form);
      const buyNowBtn = document.querySelector('[data-buy-now]');

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('is-loading');

        try {
          const formData = new FormData(form);
          const body = Object.fromEntries(formData.entries());
          await fetchJSON(window.ASTROX.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          });
          await CartDrawer.refresh();
          CartDrawer.open();
        } catch (err) {
          console.error('ASTROX: error al agregar al carrito', err);
        } finally {
          addBtn.classList.remove('is-loading');
        }
      });

      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', async () => {
          buyNowBtn.classList.add('is-loading');
          try {
            const formData = new FormData(form);
            const body = Object.fromEntries(formData.entries());
            await fetchJSON(window.ASTROX.routes.cart_add_url + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(body)
            });
            window.location.href = '/checkout';
          } catch (err) {
            console.error('ASTROX: error en compra directa', err);
            buyNowBtn.classList.remove('is-loading');
          }
        });
      }
    });
  })();

  /* ============================================================
     6. CANTIDAD Y ELIMINAR EN EL CARRITO (delegación de eventos)
     ============================================================ */
  (function cartLineItemActions() {
    document.addEventListener('click', async (e) => {
      const decreaseBtn = e.target.closest('[data-qty-decrease]');
      const increaseBtn = e.target.closest('[data-qty-increase]');
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (!decreaseBtn && !increaseBtn && !removeBtn) return;

      const itemEl = e.target.closest('[data-cart-item]');
      if (!itemEl) return;
      const line = itemEl.dataset.line;
      const qtyEl = qs('[data-qty-value]', itemEl);
      let newQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

      if (decreaseBtn) newQty = Math.max(0, newQty - 1);
      if (increaseBtn) newQty = newQty + 1;
      if (removeBtn) newQty = 0;

      itemEl.classList.add('is-loading');
      try {
        await fetchJSON(window.ASTROX.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: newQty })
        });
        await CartDrawer.refresh();
      } catch (err) {
        console.error('ASTROX: error al actualizar cantidad', err);
      } finally {
        itemEl.classList.remove('is-loading');
      }
    });
  })();

  /* ============================================================
     7. SELECTOR DE VARIANTES (talla / color)
     ============================================================ */
  (function variantSelector() {
    const page = qs('[data-product-page]');
    if (!page) return;

    qsa('[data-option-value]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.option-selector');
        qsa('[data-option-value]', group).forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const labelEl = qs('[data-selected-option-value]', group);
        if (labelEl) labelEl.textContent = btn.dataset.optionValue;
        // En una integración completa, aquí se recalcula el variant_id real
        // consultando product.variants vía JSON embebido en la sección.
      });
    });
  })();

  /* ============================================================
     8. GALERÍA DE PRODUCTO
     ============================================================ */
  (function productGallery() {
    const gallery = qs('[data-product-gallery]');
    if (!gallery) return;

    const slides = qsa('[data-gallery-slide]', gallery);
    const thumbs = qsa('[data-gallery-thumb]', gallery);
    const prevBtn = qs('[data-gallery-prev]', gallery);
    const nextBtn = qs('[data-gallery-next]', gallery);
    let current = 0;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      current = index;
    }

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    if (prevBtn) prevBtn.addEventListener('click', () => show(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(current + 1));
  })();

  /* ============================================================
     9. GUÍA DE TALLAS (modal)
     ============================================================ */
  (function sizeGuideModal() {
    const modal = qs('[data-size-guide-modal]');
    const openBtns = qsa('[data-size-guide-open]');
    const closeBtns = qsa('[data-size-guide-close]');
    if (!modal) return;

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    openBtns.forEach((btn) => btn.addEventListener('click', open));
    closeBtns.forEach((btn) => btn.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
  })();

  /* ============================================================
     10. INDICADOR DE STOCK BAJO (solo se muestra si es real)
     ============================================================ */
  (function stockIndicator() {
    const indicator = qs('[data-stock-indicator]');
    if (!indicator) return;
    const threshold = 10; // umbral configurable de "stock bajo"
    const currentQty = window.ASTROX && window.ASTROX.currentVariantInventory;

    if (typeof currentQty === 'number' && currentQty > 0 && currentQty <= threshold) {
      indicator.hidden = false;
      const fill = qs('[data-stock-bar-fill]', indicator);
      const text = qs('[data-stock-text]', indicator);
      const pct = Math.max(8, Math.round((currentQty / threshold) * 100));
      if (fill) fill.style.width = pct + '%';
      if (text) text.textContent = `Solo quedan ${currentQty} unidades`;
    }
  })();

  /* ============================================================
     11. TESTIMONIOS: arrastre táctil suave (nativo con scroll-snap)
     ============================================================ */
  // El scroll-snap CSS nativo cubre el comportamiento; no se requiere JS adicional,
  // evitando peso extra en el bundle (principio de rendimiento).

})();
